import React, { useState } from 'react';
import { Form, Input, Button, notification } from 'antd';
import api from '../../config/axiosConfig';

export default function ChangePassword() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        try {
            await api.post('/auth/change-password', {
                oldPassword: values.oldPassword,
                newPassword: values.newPassword,
            });
            notification.success({
                message: 'პაროლი წარმატებით შეიცვალა',
                placement: 'topRight',
            });
            form.resetFields(['oldPassword', 'newPassword', 'confirmPassword']);
        } catch (error) {
            notification.error({
                message: 'Error',
                description: 'Failed to save suspension. Please try again.',
                placement: 'topRight'
            });
        }
    };

    return (
        <div style={{ maxWidth: 400, margin: '0 auto', padding: '1rem' }}>
            <h3>პაროლის შეცვლა</h3>
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                requiredMark={false}
            >
                <Form.Item
                    name="oldPassword"
                    label="მიმდინარე პაროლი"
                    rules={[{ required: true, message: 'დაარედაქტირეთ მიმდინარე პაროლი' }]}
                >
                    <Input.Password placeholder="••••••••" />
                </Form.Item>

                <Form.Item
                    name="newPassword"
                    label="ახალი პაროლი"
                    rules={[
                        { required: true, message: 'შეიყვანეთ ახალი პაროლი' },
                        { min: 8, message: 'პაროლი მინიმუმ 8 სიმბოლო' },
                    ]}
                    hasFeedback
                >
                    <Input.Password placeholder="••••••••" />
                </Form.Item>

                <Form.Item
                    name="confirmPassword"
                    label="გაიმეორეთ ახალი პაროლი"
                    dependencies={['newPassword']}
                    hasFeedback
                    rules={[
                        { required: true, message: 'გაიმეორეთ ახალი პაროლი' },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('newPassword') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('პაროლები არ ემთხვევა'));
                            },
                        }),
                    ]}
                >
                    <Input.Password placeholder="••••••••" />
                </Form.Item>

                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        block
                    >
                        შეცვლა
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
}
